export function buildQueryString(
  params: { [key: string]: any },
  arrayToCommaSeparatedString = true,
  parentNode?: string,
): string {
  return Object.keys(params)
    .reduce((nodes, k) => {
      // eslint-disable-next-line functional/no-let
      let value = params[k];
      if (value === undefined || value === null) {
        return nodes;
      }

      if (typeof parentNode === 'string') {
        // eslint-disable-next-line no-param-reassign
        k = `${parentNode}[${k}]`;
      }

      if (Array.isArray(value) && arrayToCommaSeparatedString) {
        nodes.push(
          `${encodeURIComponent(k)}=${value.map(it => encodeURIComponent(it)).join(',')}`,
        );

        return nodes;
      } else if (typeof value === 'object') {
        return nodes.concat(buildQueryString(value, arrayToCommaSeparatedString, k));
      }

      if (typeof value === 'boolean') {
        value = Number(value);
      }

      nodes.push(`${encodeURIComponent(k)}=${encodeURIComponent(value)}`);

      return nodes;
    }, [] as string[])
    .join('&');
}

export function parseQueryParams(queryStringOrUri: string) {
  const queryString = queryStringOrUri.includes('?')
    ? queryStringOrUri.split('?')[1]
    : queryStringOrUri;
  const queryParams: Record<string, string> = {};

  if (queryString.includes('=')) {
    new URLSearchParams(queryString).forEach((v, k) => {
      queryParams[k] = v;
    });
  }

  return queryParams;
}

function removeQueryString(uri: string) {
  if (!uri.includes('?')) {
    return uri;
  }

  return uri.split('?')[0];
}

export function addQueryParamsToUrl(url: string, queryParams: Record<string, any>) {
  return (
    removeQueryString(url) +
    '?' +
    buildQueryString({
      ...parseQueryParams(url),
      ...queryParams,
    })
  );
}
